module.exports = __webpack_public_path__ + "static/media/logo.d248f325.svg";